import React from "react";

interface HeaderProps {
  onBlogClick: () => void;
  onAboutClick: () => void;
  onLogoClick: () => void;
}

const Header: React.FC<HeaderProps> = ({
  onBlogClick,
  onAboutClick,
  onLogoClick,
}) => (
  <header className="fixed top-0 left-0 right-0 h-14 bg-white border-b border-slate-100 z-50">
    <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
      <div
        className="font-bold text-lg tracking-tight text-slate-900 cursor-pointer"
        onClick={onLogoClick}
      >
        BabySkin<span className="text-orange-600">Q</span>
      </div>

      <div className="flex items-center gap-6">
        <button
          onClick={onAboutClick}
          className="text-sm font-bold text-slate-500 hover:text-orange-600 transition-colors uppercase tracking-wide"
        >
          About
        </button>
        <button
          onClick={onBlogClick}
          className="text-sm font-bold text-slate-500 hover:text-orange-600 transition-colors uppercase tracking-wide"
        >
          Blog
        </button>
      </div>
    </div>
  </header>
);

export default Header;
